module.exports = __webpack_public_path__ + "static/media/Jennifer-Fisher-Metallic-Triangle-Hoop-Earrings-Lyst.3fe73af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Jennifer-Fisher-Metallic-Triangle-Hoop-Earrings-Lyst.png
// module id = 237
// module chunks = 0